import React from 'react';
import { useMingo } from '../context/MingoContext';

function LoadingSpinner({ label, size = 40 }) {
  const { t } = useMingo();
  const aria = label || t('common.loadingLabel');
  return (
    <div className="mingo-spinner-wrap" role="status" aria-busy="true" aria-label={aria}>
      <div className="mingo-spinner" style={{ width: size, height: size }} />
      {label ? <p className="mingo-spinner__label">{label}</p> : null}
    </div>
  );
}

export default React.memo(LoadingSpinner);
